import { planAddDays, planMidnight, type CalCard, type CalEvent, type CalendarPlanningData } from '@kaba/shared';

export type OverviewEvent = CalEvent<CalCard> & { planning?: { id: string; state: 'planned' | 'performed' } };
export const calendarEventKey = (e: OverviewEvent) => e.planning ? `plan:${e.planning.id}:${e.startDay}` : `${e.card.id}:${e.kind}`;

/** Echte Blöcke auf sichtbare Kalendertage schneiden, niemals Kartenstart/Frist überschreiben. */
export function planningCalendarEvents(data: CalendarPlanningData | undefined, days: string[], zone: string): OverviewEvent[] {
  return (data?.blocks ?? []).flatMap(block => days.flatMap(day => {
    const begin = Math.max(Date.parse(block.start), planMidnight(day, zone));
    const end = Math.min(Date.parse(block.end), planMidnight(planAddDays(day, 1), zone));
    if (end <= begin) return [];
    return [{ card: block.card, kind: 'span' as const, startDay: day, endDay: day,
      startTime: new Date(begin).toISOString(), endTime: new Date(end).toISOString(), timed: true,
      planning: { id: block.id, state: block.state } }];
  }));
}
